var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCommunity = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.144 12.604a3.687 3.687 0 0 0-3.687 3.687v.59a.442.442 0 0 1-.885 0v-.59a4.572 4.572 0 1 1 9.144 0v.59a.442.442 0 0 1-.885 0v-.59a3.687 3.687 0 0 0-3.687-3.687Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.144 7.885a1.917 1.917 0 1 0 0 3.835 1.917 1.917 0 0 0 0-3.835ZM9.342 9.802a2.802 2.802 0 1 1 5.604 0 2.802 2.802 0 0 1-5.604 0ZM5.206 13.977a2.585 2.585 0 0 0-2.586 2.586v.414a.31.31 0 0 1-.62 0v-.414a3.206 3.206 0 0 1 6.412 0v.414a.31.31 0 0 1-.62 0v-.414a2.585 2.585 0 0 0-2.586-2.586Z",
  fill: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.206 10.668a1.344 1.344 0 1 0 0 2.69 1.344 1.344 0 0 0 0-2.69Zm-1.965 1.345a1.965 1.965 0 1 1 3.93 0 1.965 1.965 0 0 1-3.93 0ZM19.206 13.977a2.585 2.585 0 0 0-2.585 2.586v.414a.31.31 0 0 1-.621 0v-.414a3.206 3.206 0 0 1 6.412 0v.414a.31.31 0 0 1-.62 0v-.414a2.585 2.585 0 0 0-2.586-2.586Z",
  fill: "currentColor"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.206 10.668a1.344 1.344 0 1 0 0 2.69 1.344 1.344 0 0 0 0-2.69Zm-1.965 1.345a1.965 1.965 0 1 1 3.93 0 1.965 1.965 0 0 1-3.93 0Z",
  fill: "currentColor"
})));
export default SvgCommunity;